<template>
  <transition name="fade">
    <div v-if="visible" class="Toast" :class="type">
      <img :src="icon" class="Icon" :class="{ 'spin-animation': type === 'loading' }">
      <span class="Message">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: '',
      type: 'info', // info, success, error, warning, loading
      duration: 3000,
      timer: null
    }
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success': return '/icon/success.svg'
        case 'error': return '/icon/warning.svg'
        case 'warning': return '/icon/warning.svg'
        case 'loading': return '/icon/加载.svg' // 使用 加载.svg
        default: return '/icon/warning.svg'
      }
    }
  },
  methods: {
    Show(message, type = 'info', duration = 3000) {
      this.message = message
      this.type = type
      this.duration = duration
      this.visible = true
      
      if (this.timer) clearTimeout(this.timer)
      
      // 只有当 duration 大于 0 时才自动关闭
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.visible = false
        }, this.duration)
      }
    },
    // 新增手动隐藏方法
    hide() {
      this.visible = false
      if (this.timer) clearTimeout(this.timer)
    }
  }
}
</script>

<style scoped>
.Toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  display: flex;
  align-items: center;
  z-index: 9999;
  min-width: 200px;
  justify-content: center;
}

.Toast.success { border-left: 4px solid #67c23a; }
.Toast.error { border-left: 4px solid #f56c6c; }
.Toast.warning { border-left: 4px solid #e6a23c; }
.Toast.info { border-left: 4px solid #909399; }
.Toast.loading { border-left: 4px solid #409eff; }

.Icon {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.spin-animation {
  animation: spin 1s linear infinite;
  display: inline-block; /* 确保 transform 生效 */
}

@keyframes spin {
  0% { transform: rotate(360deg); }
  100% { transform: rotate(0deg); }
}

.Message {
  font-size: 14px;
  color: #606266;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s, top 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  top: 0px;
}
</style>